import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["periodSelect", "customRange"]
  static outlets = ["date-range-modal"]

  connect() {
    // Initialize inline custom-range visibility (for /balances and /dashboard which use customRangeTarget).
    // We skip the modal here so it doesn't auto-pop on page load when ?period=custom was preserved.
    if (this.hasCustomRangeTarget) {
      this.customRangeTarget.classList.toggle("hidden", this.periodSelectTarget.value !== "custom")
    }
  }

  toggleCustom() {
    const isCustom = this.periodSelectTarget.value === "custom"

    // If a date range modal is available, prefer that UX over the inline range.
    if (isCustom) {
      const modal = this.dateRangeModal()
      if (modal) {
        modal.open()
        return
      }
    }

    if (!this.hasCustomRangeTarget) return

    if (isCustom) {
      this.customRangeTarget.classList.remove("hidden")
    } else {
      this.customRangeTarget.classList.add("hidden")
    }
  }

  clientChanged() {
    // When client changes, we need to refresh the period options
    // The server will regenerate options based on the selected client's fiscal year
    // We submit the form to get updated period options

    // Clear the statement_id when client changes to avoid filtering by a statement from another client
    const statementSelect = this.element.querySelector('select[name="statement_id"]')
    if (statementSelect) {
      statementSelect.value = ""
    }

    this.element.requestSubmit()
  }

  submit() {
    // A bare "custom" selection has no dates yet — the calendar modal collects them and
    // submits on apply, so never auto-submit (which would reload into an empty range).
    if (this.periodSelectTarget && this.periodSelectTarget.value === "custom") {
      return
    }

    // Clear stale custom-range dates so they don't leak into non-custom queries.
    const startField = this.element.elements.namedItem("start_date")
    const endField = this.element.elements.namedItem("end_date")
    if (startField) startField.value = ""
    if (endField) endField.value = ""

    this.element.requestSubmit()
  }

  // Resolve the date-range-modal controller. Prefer the wired Stimulus outlet, but fall
  // back to a direct lookup since outlet wiring can lag for a modal nested inside this form.
  dateRangeModal() {
    if (this.hasDateRangeModalOutlet) return this.dateRangeModalOutlet

    const selector = this.element.getAttribute("data-period-filter-date-range-modal-outlet")
    if (!selector) return null

    const element = document.querySelector(selector)
    return element ? this.application.getControllerForElementAndIdentifier(element, "date-range-modal") : null
  }
}
